import React, { useContext } from "react";

// External components
import { Helmet } from "react-helmet";

import { DataContext } from "contexts/Data";

const Meta = ({ description, image, title }) => {
    const { data } = useContext(DataContext);
    let globalTitle = data.seo.home.title;
    let globalDescription = data.seo.home.description;
    let globalImage = data.seo.home.image;
    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{title || globalTitle}</title>
            <meta name="title" content={title || globalTitle} />
            <meta
                name="description"
                content={description || globalDescription}
            />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title || globalTitle} />
            <meta
                property="og:description"
                content={description || globalDescription}
            />
            <meta property="og:image" content={image || globalImage} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:title" content={title || globalTitle} />
            <meta
                property="twitter:description"
                content={description || globalDescription}
            />
            <meta
                property="twitter:image"
                content={image || globalImage}
            ></meta>
        </Helmet>
    );
};

export default Meta;
